module.exports = __webpack_public_path__ + "img/calvin.9c0aa935.png";